import { render, staticRenderFns } from "./Hedge.vue?vue&type=template&id=4fe9e5ca&scoped=true&"
import script from "./Hedge.vue?vue&type=script&lang=js&"
export * from "./Hedge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe9e5ca",
  null
  
)

export default component.exports